// state.js

export default {
    rulesList: [],
    devicesInfo: {},
    selectedDeviceRules: [],
};
